import { useEffect, useState } from "react";
// import NewPanicAlertTicket from "./NewPanicAlertTicket";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PanicAlertTicket from "./PanicAlertTicket";
import { getFormattedDate } from "../utils/getDate";
import { useUser } from "../Contexts/UserContext";
import ThreeDotLoader from "./ThreeDotLoader";
// import { GrRefresh } from "react-icons/gr";
// import DownloadExcelButton from "./DownloadExcelBtn";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const PanicAlertTable = ({
  handleDefaultTableData,
  defaultTableData,
  handleCheckBoxChange,
  isChecked,
  showTicket,
  setShowTicket,
  ticketData,
  setTicketData,
  onTicketHandleClick,
  setRemark,
  checkbox,
  setCheckbox,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [tempTableData, setTempTableData] = useState([]);
  // const handleCheckboxChange = async () => {
  //   setIsChecked(!isChecked);
  //   if (!isChecked) {
  //     const response = await fetch(
  //       `http://125.63.103.94:82/WebService.asmx/DefoulterListMonitoring?IsHandled=1&CompanyCode=&BranchCode=`
  //     ).then((res) => res.json());
  //     setTableData(response);
  //   } else {
  //     const response = await fetch(
  //       `http://125.63.103.94:82/WebService.asmx/DefoulterListMonitoring?IsHandled=0&CompanyCode=&BranchCode=`
  //     ).then((res) => res.json());
  //     setTableData(response);
  //     // getDefaultData(response);
  //     // setTableData(response);
  //   }
  // };
  const { user } = useUser();
  const date = getFormattedDate();
  const getDefaultData = async () => {
    if (defaultTableData.length !== 0) {
      setTableData(defaultTableData);
      return;
    }
    const response = await fetch(
      `http://125.63.103.94:82/WebService.asmx/DefoulterListMonitoring?IsHandled=0&CompanyCode=&BranchCode=`
    ).then((res) => res.json());
    setTableData(response);
    handleDefaultTableData(response);
    handleSearch(searchTerm);
  };
  const internalTableRefresh = async () => {
    const response = await fetch(
      `http://125.63.103.94:82/WebService.asmx/ShowPanicDetailInDeshBoard?IsHandle=0&CompanyCode=`
    ).then((res) => res.json());
    handleDefaultTableData(response);
    // handleSearch(searchTerm);
    setShowTicket(false);
    handleCheckBoxChange(false);
  };
  const handleRefresh = () => {
    internalTableRefresh();
  };
  const handleShowTicket = (data) => {
    console.log("Ticket Data", data);
    setShowTicket(true);
    setTicketData(data);
  };
  const handleSearch = (searchTerm = "") => {
    const searchTermLower = searchTerm.toLowerCase();
    const filteredData = defaultTableData.filter((item) =>
      Object.values(item).some((value) =>
        value.toString().toLowerCase().includes(searchTermLower)
      )
    );
    setTableData(filteredData);
  };
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `${API_URL}/facility/get-post-panic-reports/1/${user.CompCode}/${user.ClientId}/Testing/Suraj/6/${date}/${date}`
      ).then((res) => res.json());
      if (response.success) {
        setTableData(response.data);
        handleDefaultTableData(response.data);
        setIsLoading(false);
      } else {
        alert("Error in loading Panics :( ");
        setIsLoading(false);
      }
    };

    fetchData();

    // const intervalId = setInterval(internalTableRefresh, 5000);
    // return () => clearInterval(intervalId);
  }, []);

  // Listening for changes in defaultTableData prop and updating the table data accordingly
  useEffect(() => {
    setTableData(defaultTableData);
  }, [defaultTableData]);

  return (
    <div className="alertTable-container">
      {showTicket ? (
        <PanicAlertTicket
          setShowTicket={setShowTicket}
          ticketData={ticketData}
          isHandled={isChecked}
          onTicketHandleClick={onTicketHandleClick}
          setRemark={setRemark}
        />
      ) : null}
      <div className="panic__container">
        <nav className="panic__nav">
          <div className="searchbox">
            <input type="text" placeholder="search" />
            <button className="panic__nav_searchBtn">Search</button>
          </div>
          <aside className="panic__nav_aside">
            <div className="checkbox">
              <input
                type="checkbox"
                id="checkbox"
                checked={checkbox == 1}
                onChange={() => setCheckbox(1)}
              />
              <label for="checkbox">Open</label>
            </div>
            <div className="checkbox">
              <input
                type="checkbox"
                id="checkbox"
                checked={checkbox == 0}
                onChange={() => setCheckbox(0)}
              />
              <label for="checkbox">All</label>
            </div>
            <div className="checkbox">
              <input
                type="checkbox"
                id="checkbox"
                checked={checkbox == 2}
                onChange={() => setCheckbox(2)}
              />
              <label for="checkbox">Closed</label>
            </div>
          </aside>
        </nav>
        <header className="panic__header">
          <div className="panic__header_row">
            <span className="size__medium">UnitCode</span>
            <span className="size__large">UnitName</span>
            <span className="size__medium">EmpCode</span>
            <span className="size__large">EmpName</span>
            <span className="size__large">PanicType</span>
            <span className="size__medium">Contact</span>
            <span className="size__medium">Remark</span>
            <span className="size__medium">Status</span>
            <span className="size__small">Detail</span>
          </div>
        </header>
        <main className="panic__list_container">
          {!isLoading &&
            tableData.map((row) => (
              <>
                <div className="panic__list_row">
                  <span className="size__medium">{row.UnitCode}</span>
                  <span className="size__large">{row.UnitName}</span>
                  <span className="size__medium">{row.EmpCode}</span>
                  <span className="size__large">{row.EmpName}</span>
                  <span className="size__large">{row.PanicType}</span>
                  <span className="size__medium">{row.Mobile}</span>
                  <span className="size__medium">{row.Remark}</span>
                  <span className="size__medium">
                    {row.Status == null ? "Open" : "Closed"}
                  </span>
                  <span className="size__small">
                    <button onClick={() => handleShowTicket(row)} id="view-btn">
                      <VisibilityIcon />
                    </button>
                  </span>
                </div>
              </>
            ))}
          {isLoading && <ThreeDotLoader />}
        </main>
      </div>
    </div>
  );
};
export default PanicAlertTable;
